export default __webpack_public_path__ + "static/media/outdoor-1.9abda154.png";